import React from 'react';
import { SkeletonComponent } from '@design-system';

export const FavoritesSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '0', display: 'flex', gap: '16px', flexDirection: 'row', height: '130px' }}>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '130px',
                        width: '115px',
                        borderRadius: '18px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
